import { useCompanyDetails } from '../company-details-context';
import { CompanyConnectorSection } from '../components/CompanyConnectorSection';

export function CompanyDetailsConnectorTab() {
  const { company, isPurged } = useCompanyDetails();
  if (isPurged) return <p className="text-sm text-gray-500">Os dados operacionais desta empresa foram removidos.</p>;
  return <section className="space-y-4"><header><h2 className="text-lg font-semibold">Orya Connector</h2><p className="text-sm text-gray-500">Gateway, atualizações e diagnóstico da empresa.</p></header><CompanyConnectorSection companyId={company.id} /></section>;
}
